import { useQueryParams } from 'ssr/router'
import { Seo, USER_PROFILE_TAB } from 'ui-components'
import { getUserLink } from 'utils'
import { UserProfile } from './UserProfile'

export const App = (props) => {
  const { page, hasNextPage } = props
  const { userId, username, tab } = useQueryParams()

  return (
    <>
      <Seo
        title={username ? `${username} - profile` : 'Loading...'}
        additionalLinkTags={[
          ...(tab === USER_PROFILE_TAB.MAPS && page > 1
            ? [
                {
                  rel: 'prev',
                  href: getUserLink({
                    userId,
                    username,
                    tab: USER_PROFILE_TAB.MAPS,
                    page: page - 1
                  })
                }
              ]
            : []),
          ...(tab === USER_PROFILE_TAB.MAPS && hasNextPage
            ? [
                {
                  rel: 'next',
                  href: getUserLink({
                    userId,
                    username,
                    tab: USER_PROFILE_TAB.MAPS,
                    page: page + 1
                  })
                }
              ]
            : [])
        ]}
      />
      <UserProfile {...props} />
    </>
  )
}
